<script>
import { defineComponent, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'   
//helper
import { FormHelper, DropdownListValue } from '@/helper/FormHelper' 
//components
import InputText from '../Input/InputText.vue'
import InputDropdown from '../Input/InputDropdown.vue'
//service
import Topup2c2pService from "../../service/Topup2c2pService"
//feature
import { useLandingFlow } from '../../feature/LandingFlowFeature'
import { useLocale } from '../../feature/LocaleFeature'

export default defineComponent({
    components: {
        InputText,
        InputDropdown
    },
    setup: () => {
        const { query, campaign} = useLandingFlow()
        const { localeCode, lbl } = useLocale()
        const route = useRoute()

        const isLoaded = ref(false)
        const listInfo = ref(null)
        const errorInfo = ref([])
        const inputEl = ref([])
        const labelEl = ref([])
        const dropdownList = ref([])
        const isSubmitted = ref(false)

        

        const submitForm = () => {
            isSubmitted.value = true
            if (validateForm()) {
                console.log('submit')
                return true
            }
            return false
        }

        const getValue = () => {
            let value = {}

            for (let i = 0; i < listInfo.value.length; i++) {
                value[listInfo.value[i].Field] = inputEl.value[i].value
            }

            return value;
        }

        function validateForm() {
            let valid = FormHelper.validate(errorInfo.value);
            return valid;
        }


        const init = async () => {
            console.log("campaign", campaign.value)
            await getInfo()
            generateForm()
        }

        const generateForm = () => {
            inputEl.value = FormHelper.genFormInfo(listInfo.value.length)
            errorInfo.value = FormHelper.genErrorInfo(listInfo.value.length)
            labelEl.value = listInfo.value.map((item) => {
                if (item.Datas && item.Datas.length > 0) {
                    return {
                        name: localeCode.value === 1033 ? item.HeaderEN : item.Header,
                        placeholder: localeCode.value === 1033 ? lbl.value.detail.select + item.HeaderEN : lbl.value.detail.select + item.Header,
                        required: localeCode.value === 1033 ? lbl.value.detail.please_select + item.HeaderEN : lbl.value.detail.please_select + item.Header,
                        too_short: '',
                        invalid: '',
                    }
                } else {
                    return {
                        name: localeCode.value === 1033 ? item.HeaderEN : item.Header,
                        placeholder: localeCode.value === 1033 ? lbl.value.detail.fill + item.HeaderEN : lbl.value.detail.fill + item.Header,
                        required: localeCode.value === 1033 ? lbl.value.detail.please_enter + item.HeaderEN : lbl.value.detail.please_enter + item.Header,
                        too_short: '',
                        invalid: '',
                    }
                }
                
            })
            dropdownList.value = listInfo.value.map((item) => {
                let itemList = []
                if (item.Datas && item.Datas.length > 0) {
                    itemList = new DropdownListValue()
                    item.Datas.forEach((item) => {
                        itemList.add(localeCode.value === 1033 ? item.TextEN : item.Text, item.Value)
                    })
                }
               
                return {
                    itemList,
                }
            })
            isLoaded.value = true
        }

        const getInfo = () => {
            return new Promise((resolve) => {
                Topup2c2pService.apiGetInfo(query.value.token, route.params.categoryId, query.value.appId, query.value.jwt).subscribe({
                    next: (data) => {
                        listInfo.value = data
                        resolve(data)
                    },
                    error: (err) => {
                        console.log(err)
                        resolve()
                    },
                });
            });
            
        }
        
        onMounted(() => {
            init()
        })

        return {
            campaign,
            listInfo,
            inputEl,
            labelEl,
            dropdownList,
            isLoaded,
            isSubmitted,
            errorInfo,
            submitForm,
            getValue,
            lbl
        }
    }
})
</script>
<template>
    <div v-if="isLoaded" class="bg-white">
        <div class="px-5">
            <div class="flex py-2 border-b border-a-gray-e5e5e5">
                <div><img class="h-5 my-auto mr-2"  src="../../assets/icon/file-light.svg" /></div>
                <div class="text-14 text-a-gray-4a4a4a my-auto">{{ lbl.detail.game_info }}</div>
            </div>
        </div>
        <div class="px-5 py-2">
            <div v-for="(info,index) in listInfo" 
                :key="index"
                :class="{'pb-4': index != listInfo.length - 1}">
                <div v-if="info.Datas && info.Datas.length > 0">
                    <InputDropdown 
                        v-model:inputValue="inputEl[index].value"
                        :itemList="dropdownList[index].itemList.list"
                        :errorInfo="errorInfo[index]"
                        :isSubmitted="isSubmitted"
                        :inputLbl="labelEl[index]"
                        :isShowError="true"
                    ></InputDropdown>
                </div>
                <div v-else>
                    <InputText  
                        v-model:inputValue="inputEl[index].value"
                        :errorInfo="errorInfo[index]"
                        :isSubmitted="isSubmitted"
                        :inputLbl="labelEl[index]"
                        :isShowError="true"
                    ></InputText>
                </div>
            </div>  
        </div>
        
    </div>
</template>